export default {
  path: '/help',
  redirect: { name: 'help' },
  component: () => import('@/pages/s'),
  children: [
      {
          path: 'index',
          name: 'help',
          component: () => import('@/pages/help/index.vue')
      },
      {
          path: 'detail/:id',
          name: 'helpdetail',
          component: () => import('@/pages/help/detail.vue')
      },
  ]
}
